import { config } from './config';

import createReactI18nInstance from '../utils';

export const i18n = createReactI18nInstance(config);
